import type * as api from '@gitbook/api-client';
import { validateAnyContentReference } from '@gitbook/app-content-refs';
import { Inline, Schema } from '@gitbook/slate';

import { INLINE_LINK, INLINE_MENTION, type InlineLinkData } from '../types';

export const schema = Schema.create({
    inlines: {
        [INLINE_MENTION]: {
            isVoid: true,
            data: {
                ref: validateAnyContentReference,
            },
        },
    },
});

/**
 * Schema to replace all links by mentions.
 * It can be used in context where we don't support links (like in basic editor)
 */
export const schemaReplaceLinks = Schema.create({
    validations: [
        (node) => {
            if (node.object !== 'inline' || node.type !== INLINE_LINK) {
                return null;
            }

            return (change) => {
                change.replaceNodeByKey(
                    node.key,
                    createMention((node.data.toFrozenObject() as InlineLinkData).ref)
                );
            };
        },
    ],
});

/**
 * Create a mention for the given ref.
 */
export function createMention(ref: api.ContentRef): Inline {
    return Inline.createVoid({
        type: INLINE_MENTION,
        data: {
            ref,
        },
    });
}
